// extracted by mini-css-extract-plugin
module.exports = {"passageTest":"PassageTest_passageTest__3J4MT"};